import { render, staticRenderFns } from "./IcoMobileDevice.vue?vue&type=template&id=7299f5d8"
import script from "./IcoMobileDevice.vue?vue&type=script&lang=js"
export * from "./IcoMobileDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports